import './Support.scss'
import React from 'react';
import Script from 'react-load-script'

import {
  POOLED_BROKER_SUCCESS_SUPPORT_LABEL,
  POOLED_BROKER_SUCCESS_REP_PHONE,
  POOLED_BROKER_SUCCESS_SUPPORT_EMAIL,
} from "common/constants";

const BLASupportTile = ({support}) => (
  <div className="BrokerSupport__tile">
    <div className="BrokerSupport__acct-mgr-icon"/>
    <span className="BrokerSupport__tile_heading">Contact your dedicated<br/>Opcity Broker Success Rep:</span>
    <span className="BrokerSupport__tile_description">
      {support.name} <a href={`mailto:${support.email}`}>{support.email}</a><br/>
      {support.phone}
    </span>
  </div>
)

const PooledBLASupportTile = () => (
  <div className="BrokerSupport__tile">
      <div className="BrokerSupport__acct-mgr-icon"/>
      <span className="BrokerSupport__tile_heading">Contact Opcity Broker Support:</span>
      <span className="BrokerSupport__tile_description">
        <a href={POOLED_BROKER_SUCCESS_SUPPORT_LABEL.value} target="_blank" rel="noopener noreferrer">
          {POOLED_BROKER_SUCCESS_SUPPORT_LABEL.label}
        </a><br/><a href={`mailto:${POOLED_BROKER_SUCCESS_SUPPORT_EMAIL}`}>
          {POOLED_BROKER_SUCCESS_SUPPORT_EMAIL}
        </a><br/>{POOLED_BROKER_SUCCESS_REP_PHONE}
      </span>
  </div>
)

const Support = (props) => {

  const { account } = props

  return (
    <div className="BrokerSupport">
      <div className="BrokerSupport__contact">
        <div className="BrokerSupport__title-text">Opcity Customer Support</div>
        <div className="BrokerSupport__tile-container">
          <div className="BrokerSupport__tile">
            <div className="BrokerSupport__need-help-icon"/>
            <span className="BrokerSupport__tile_heading">Need Help?</span>
            <span className="BrokerSupport__tile_description">
              Visit the <a target="_blank" rel="noopener noreferrer" href="https://support.realtor.com/">Support Portal</a> for
              answers to commonly asked questions or to submit a help request.
            </span>
          </div>
          { account.is_partner_brokerage && account.success_rep && <BLASupportTile support={account.success_rep} /> }
          { account.is_partner_brokerage && !account.success_rep && <PooledBLASupportTile/> }
          <div className="BrokerSupport__tile">
            <div className="BrokerSupport__acct-questions-icon"/>
            <span className="BrokerSupport__tile_heading">Accounting related questions...</span>
            <span className="BrokerSupport__tile_description">
              Including those about outstanding balances, please read <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://support.realtor.com/s/article/My-agent-just-closed-a-transaction-How-do-I-make-sure-they-get-credit-for-their-close">
                  these articles
              </a> before submitting a request.
            </span>
          </div>
        </div>

        <div className="BrokerSupport__contact--text">
          {!!account.standard_agreement_link
            && !account.standard_agreement_link.includes('/s3/path/here') &&
            <a className="BrokerSupport__contact--agreement" href={account.standard_agreement_link} target="_newtab">
              <i className="fa fa-download"></i>Download your Opcity Brokerage Participation Agreement<br/><br/>
            </a>
          }
            <a className="BrokerSupport__contact--agreement" href="/referral-fees">
              <i className="fa fa-dollar"></i> View ReadyConnect Concierge referral & applicable broker fees
            </a>
        </div>
      </div>

      <div className="BrokerSupport__webinar-wrapper">
        <div className="BrokerSupport__title-text">
          Want to learn more about the Opcity program?
        </div>

        <div className="BrokerSupport__tile-container">
          <div className="BrokerSupport__video-tile">
            <div className="BrokerSupport__section-text">Using the Broker Portal</div>

            <div className="BrokerSupport__video-wrapper">
              <iframe width="560" height="315" src="https://player.vimeo.com/video/942127601?h=864047db36"
                      title="Vimeo video player" frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowFullScreen>

              </iframe>
            </div>

            <div className="BrokerSupport__sub-text">Learn how to navigate the Broker Portal to effectively manage your team and project your potential revenue from Opcity.</div>
          </div>

          <div className="BrokerSupport__video-tile">
            <div className="BrokerSupport__section-text">Using Referral Manager</div>

            <div className="BrokerSupport__video-wrapper">
              <iframe width="560" height="315" src="https://www.youtube.com/embed/6am5tYoEVJs"
                      title="YouTube video player" frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowFullScreen>

              </iframe>
            </div>

            <div className="BrokerSupport__sub-text">Watch our demo video to learn how to access Referral Manager, update your leads, and manage important settings.</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Support
